import React from "react";
import Logo from "../assets/logo/logo.png";
import { useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 h-20 bg-white border-b border-gray-200"
      role="navigation"
    >
      {/* Full-width row; items pinned to edges */}
      <div className="flex h-full items-center px-4 sm:px-6">
        {/* Bigger logo */}
        <a href="/" className="shrink-0 flex items-center">
          {/* tweak heights if you want it even larger */}
          <img
            src={Logo}
            alt="AllergyPatrol"
            className="h-12 sm:h-14 w-auto"  /* 48px mobile, 56px+ desktop */
          />
        </a>

        {/* Right-side nav */}
        <nav className="ml-auto flex items-center gap-6">
          {location.pathname !== "/about" && (
            <a
              href="/about"
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors"
            >
              About Me
            </a>
          )}
          <a
            href="/"
            className="text-gray-700 hover:text-blue-600 font-medium transition-colors"
          >
            Home
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
